<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 class="mr-2"
                 :color="iconColor"
                 v-on="{ ...onTooltip, ...on }"
                 @click.stop.prevent=""
          >
            <v-icon>{{ icon }}</v-icon>
          </v-btn>
        </template>
        <span>Filtrar por</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row dense class="mt-1">
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            input-class="rounded-tag-small"
                            label="Data Entrada Inicial"
                            v-model="localDataInicial"/>
          </v-col>
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            input-class="rounded-tag-small"
                            label="Data Entrada Final"
                            v-model="localDataFinal"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-comprador
              required
              dense
              class="rounded-tag-small"
              v-model="localEmpresa"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <px-autocomplete-locais-entrega
              dense
              class="rounded-tag-small"
              v-model="localLocalEntrega"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-user-comprador-multiple
              required
              dense
              label="Solicitantes responsáveis"
              :roles="['ROLE_REQUISICAO']"
              class="rounded-tag-small"
              v-model="localResponsavel"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-user-comprador-multiple
              required
              dense
              show-empty-user
              label="Compradores responsáveis"
              :roles="['ROLE_COMPRADOR']"
              class="rounded-tag-small"
              v-model="localCompradorResponsavel"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-produto-multiple v-model="localProduto"
                                     class="rounded-tag-small"
                                     show-details
                                     dense
                                     base-path="/produtos/page"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-centro-custo-multiple
              class="rounded-tag-small"
              dense
              v-model="localCentroCusto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-projeto-multiple
              dense
              class="rounded-tag-small"
              v-model="localProjeto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-select-enum
              dense
              multiple
              chips
              small-chips
              label="Urgência"
              deletable-chips
              :items="urgencias"
              class="rounded-tag-small"
              v-model="localUrgencia"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-grupo-multiple
              dense
              class="rounded-tag-small"
              v-model="localGrupo"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-select-enum
              dense
              multiple
              chips
              small-chips
              label="Situação"
              deletable-chips
              :items="situacoes"
              class="rounded-tag-small"
              v-model="localSituacao"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-spacer/>
        <v-btn text class="normal-btn-text" @click="clearFilters">
          Limpar filtros
        </v-btn>
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="emitChange">
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { UrgenciaRequisicao, SituacaoRequisicao } from 'px-business-components';
import { mapGetters } from 'vuex';

export default {
  props: {},
  data: () => ({
    menuOpened: false,
    localEmpresa: null,
    localLocalEntrega: null,
    localCentroCusto: [],
    localProduto: [],
    localProjeto: [],
    localResponsavel: [],
    localDataInicial: null,
    localDataFinal: null,
    localUrgencia: [],
    localCompradorResponsavel: [],
    localGrupo: [],
    localSituacao: [],
    urgencias: UrgenciaRequisicao.values,
  }),
  computed: {
    ...mapGetters('listagemRequisicao', ['hasCustomFilters']),
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
    icon() {
      return this.hasCustomFilters ? 'mdi-filter' : 'mdi-filter-outline';
    },
    situacoes() {
      const keys = [
        SituacaoRequisicao.keys.RECEBIDA.key,
        SituacaoRequisicao.keys.EM_COMPRA.key,
        SituacaoRequisicao.keys.EM_COTACAO.key,
      ];
      return SituacaoRequisicao.values.filter(val => keys.includes(val.key));
    },
    empresa: {
      get() {
        return this.$store.getters['listagemRequisicao/empresa'];
      },
      set(empresa) {
        this.$store.dispatch('listagemRequisicao/empresa', empresa);
      },
    },
    localEntrega: {
      get() {
        return this.$store.getters['listagemRequisicao/localEntrega'];
      },
      set(localEntrega) {
        this.$store.dispatch('listagemRequisicao/localEntrega', localEntrega);
      },
    },
    centroCusto: {
      get() {
        return this.$store.getters['listagemRequisicao/centroCusto'];
      },
      set(centroCusto) {
        this.$store.dispatch('listagemRequisicao/centroCusto', centroCusto);
      },
    },
    produto: {
      get() {
        return this.$store.getters['listagemRequisicao/produto'];
      },
      set(produto) {
        this.$store.dispatch('listagemRequisicao/produto', produto);
      },
    },
    projeto: {
      get() {
        return this.$store.getters['listagemRequisicao/projeto'];
      },
      set(projeto) {
        this.$store.dispatch('listagemRequisicao/projeto', projeto);
      },
    },
    responsavel: {
      get() {
        return this.$store.getters['listagemRequisicao/responsavel'];
      },
      set(responsavel) {
        this.$store.dispatch('listagemRequisicao/responsavel', responsavel);
      },
    },
    dataFinal: {
      get() {
        return this.$store.getters['listagemRequisicao/dataFinal'];
      },
      set(dataFinal) {
        this.$store.dispatch('listagemRequisicao/dataFinal', dataFinal);
      },
    },
    dataInicial: {
      get() {
        return this.$store.getters['listagemRequisicao/dataInicial'];
      },
      set(dataInicial) {
        this.$store.dispatch('listagemRequisicao/dataInicial', dataInicial);
      },
    },
    urgencia: {
      get() {
        return this.$store.getters['listagemRequisicao/urgencia'];
      },
      set(urgencia) {
        this.$store.dispatch('listagemRequisicao/urgencia', urgencia);
      },
    },
    compradorResponsavel: {
      get() {
        return this.$store.getters['listagemRequisicao/compradorResponsavel'];
      },
      set(compradorResponsavel) {
        this.$store.dispatch('listagemRequisicao/compradorResponsavel', compradorResponsavel);
      },
    },
    grupo: {
      get() {
        return this.$store.getters['listagemRequisicao/grupo'];
      },
      set(grupos) {
        this.$store.dispatch('listagemRequisicao/grupo', grupos);
      },
    },
    situacao: {
      get() {
        return this.$store.getters['listagemRequisicao/situacao'];
      },
      set(situacao) {
        this.$store.dispatch('listagemRequisicao/situacao', situacao);
      },
    },
  },
  methods: {
    emitChange() {
      this.empresa = this.localEmpresa;
      this.localEntrega = this.localLocalEntrega;
      this.centroCusto = this.localCentroCusto;
      this.produto = this.localProduto;
      this.projeto = this.localProjeto;
      this.responsavel = this.localResponsavel;
      this.dataInicial = this.localDataInicial;
      this.dataFinal = this.localDataFinal;
      this.urgencia = this.localUrgencia;
      this.compradorResponsavel = this.localCompradorResponsavel;
      this.grupo = this.localGrupo;
      this.situacao = this.localSituacao;
      this.$emit('change');
      this.close();
    },
    clearFilters() {
      this.localEmpresa = null;
      this.localLocalEntrega = null;
      this.localCentroCusto = null;
      this.localProduto = null;
      this.localProjeto = null;
      this.localResponsavel = null;
      this.localDataInicial = null;
      this.localDataFinal = null;
      this.localUrgencia = null;
      this.localCompradorResponsavel = null;
      this.localGrupo = null;
      this.localSituacao = null;
      this.emitChange();
    },
    close() {
      this.menuOpened = false;
    },
  },
  created() {
    this.localEmpresa = this.empresa || null;
    this.localLocalEntrega = this.localEntrega || null;
    this.localCentroCusto = this.centroCusto || [];
    this.localProduto = this.produto || [];
    this.localProjeto = this.projeto || [];
    this.localResponsavel = this.responsavel || [];
    this.localDataInicial = this.dataInicial || null;
    this.localDataFinal = this.dataFinal || null;
    this.localUrgencia = this.urgencia || null;
    this.localCompradorResponsavel = this.compradorResponsavel || [];
    this.localGrupo = this.grupo || [];
    this.localSituacao = this.situacao || [];
  },
};
</script>
